var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Model from './Model';
import { computed, observable } from "mobx";
import Battery from '../data/BatteryStatus';
import ActivityStatus from '../data/ActivityStatus';
var DeviceModel = /** @class */ (function (_super) {
    __extends(DeviceModel, _super);
    function DeviceModel(data) {
        if (data === void 0) { data = {}; }
        return _super.call(this, data) || this;
    }
    DeviceModel.prototype.initialize = function (data) {
        this.link_device_id = '';
        this.link_device_id_serial = '';
        this.model = '';
        this.name = '';
        this.deviceType = null;
        this.locationLatest = null;
        this.locationAccurate = null;
        this.lastConnectedTimestampMs = null;
        this.batteryRemainingPct = null;
    };
    /**
     *
     * @param data
     */
    DeviceModel.prototype.update = function (data) {
        var _this = this;
        if (!data)
            return;
        var keys = Object.keys(data);
        keys.map(function (key) {
            switch (key) {
                default:
                    _this[key] = data[key];
            }
        });
    };
    Object.defineProperty(DeviceModel.prototype, "filterString", {
        /**
         *
         * @return {string}
         */
        get: function () {
            var _this = this;
            var s = '';
            var keys = Object.keys(this);
            // Attributes
            keys.map(function (key) {
                switch (key) {
                    default:
                        s += _this[key] + '\n';
                }
            });
            return s.toLowerCase();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DeviceModel.prototype, "hasLocation", {
        get: function () {
            return this.locationDateTime != null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DeviceModel.prototype, "location", {
        get: function () {
            if (this.locationAccurate) {
                return this.locationAccurate;
            }
            else if (this.locationLatest) {
                return this.locationLatest;
            }
            else {
                return { latitude: 0, longitude: 0, timestampMs: 0 };
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DeviceModel.prototype, "place", {
        get: function () {
            return (this.location.place === "" || this.location.place === null) ? (this.location.latitude + ', ' + this.location.longitude) : this.location.place;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DeviceModel.prototype, "displayName", {
        get: function () {
            var _a;
            return (_a = this.name) !== null && _a !== void 0 ? _a : this.link_device_id_serial;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DeviceModel.prototype, "googleMapsUrl", {
        get: function () {
            return this.location ? 'https://www.google.com/maps/search/?api=1&query=' + this.location.latitude + ',' + this.location.longitude : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DeviceModel.prototype, "locationDateTime", {
        get: function () {
            var _a, _b;
            return ((_a = this.location) === null || _a === void 0 ? void 0 : _a.timestampMs) ? new Date(Number((_b = this.location) === null || _b === void 0 ? void 0 : _b.timestampMs)) : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DeviceModel.prototype, "batteryRemainingPctValue", {
        get: function () {
            return this.batteryRemainingPct ? Math.round(this.batteryRemainingPct.value) : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DeviceModel.prototype, "batteryRemainingPctDateTime", {
        get: function () {
            var _a;
            return new Date(Number((_a = this.batteryRemainingPct) === null || _a === void 0 ? void 0 : _a.timestampMs));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DeviceModel.prototype, "lastConnectedDateTime", {
        get: function () {
            var _a;
            return new Date(Number((_a = this.lastConnectedTimestampMs) === null || _a === void 0 ? void 0 : _a.value));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DeviceModel.prototype, "activityStatus", {
        get: function () {
            // Activity logic
            var dt = Date.now() - this.lastConnectedDateTime.getTime();
            if (dt <= 3600000 * 24 * 4) { // 4 days
                return ActivityStatus.RECENT;
            }
            else if (dt <= 3600000 * 24 * 8) { // 8 days
                return ActivityStatus.EXPIRED;
            }
            return ActivityStatus.NONE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DeviceModel.prototype, "fourBarBatterySample", {
        get: function () {
            if (this.batteryRemainingPctValue && this.batteryRemainingPctValue >= 0) {
                if (this.batteryRemainingPctValue <= 25) {
                    return Battery.LOW;
                }
                if (this.batteryRemainingPctValue <= 50) {
                    return Battery.MEDIUM;
                }
                if (this.batteryRemainingPctValue <= 75) {
                    return Battery.HIGH;
                }
                return Battery.FULL;
            }
            return Battery.NONE;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        observable
    ], DeviceModel.prototype, "link_device_id", void 0);
    __decorate([
        observable
    ], DeviceModel.prototype, "link_device_id_serial", void 0);
    __decorate([
        observable
    ], DeviceModel.prototype, "attachedToAsset", void 0);
    __decorate([
        observable
    ], DeviceModel.prototype, "model", void 0);
    __decorate([
        observable
    ], DeviceModel.prototype, "name", void 0);
    __decorate([
        observable
    ], DeviceModel.prototype, "deviceType", void 0);
    __decorate([
        observable
    ], DeviceModel.prototype, "lastConnectedTimestampMs", void 0);
    __decorate([
        observable
    ], DeviceModel.prototype, "batteryRemainingPct", void 0);
    __decorate([
        observable
    ], DeviceModel.prototype, "locationLatest", void 0);
    __decorate([
        observable
    ], DeviceModel.prototype, "locationAccurate", void 0);
    __decorate([
        computed
    ], DeviceModel.prototype, "filterString", null);
    __decorate([
        computed
    ], DeviceModel.prototype, "hasLocation", null);
    __decorate([
        computed
    ], DeviceModel.prototype, "location", null);
    __decorate([
        computed
    ], DeviceModel.prototype, "place", null);
    __decorate([
        computed
    ], DeviceModel.prototype, "displayName", null);
    __decorate([
        computed
    ], DeviceModel.prototype, "googleMapsUrl", null);
    __decorate([
        computed
    ], DeviceModel.prototype, "locationDateTime", null);
    __decorate([
        computed
    ], DeviceModel.prototype, "batteryRemainingPctValue", null);
    __decorate([
        computed
    ], DeviceModel.prototype, "batteryRemainingPctDateTime", null);
    __decorate([
        computed
    ], DeviceModel.prototype, "lastConnectedDateTime", null);
    __decorate([
        computed
    ], DeviceModel.prototype, "activityStatus", null);
    __decorate([
        computed
    ], DeviceModel.prototype, "fourBarBatterySample", null);
    return DeviceModel;
}(Model));
export default DeviceModel;
